import '@babel/polyfill'
import Vue from 'vue'
// import VueAnalytics from 'vue-analytics'
import VueLogger from 'vuejs-logger'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueLodash from 'vue-lodash'
import VeeValidate from 'vee-validate'
import axios from 'axios'
import VueAxios from 'vue-axios'
import MugenScroll from 'vue-mugen-scroll'
import SnackbarStackPlugin from 'snackbarstack'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import AuthService from './services/auth.service'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import { constants } from '@/consts'

Vue.use(VueLogger, {
  // optional : defaults to true if not specified
  isEnabled: process.env.VUE_APP_LOG_ENABLED === 'true',
  // required ['debug', 'info', 'warn', 'error', 'fatal']
  logLevel: 'debug',
  // optional : defaults to false if not specified
  stringifyArguments: false,
  // optional : defaults to false if not specified
  showLogLevel: false,
  // optional : defaults to false if not specified
  showMethodName: false,
  // optional : defaults to '|' if not specified
  separator: '|',
  // optional : defaults to false if not specified
  showConsoleColors: false
})

Vue.use(SnackbarStackPlugin, { duration: 10000 })

Vue.config.productionTip = false

Vue.use(VueMoment, { moment })
Vue.use(VueLodash, { name: 'lodash' })

Vue.use(VeeValidate, {
  dictionary: {
    en: {
      custom: {
        confirm: {
          required: () => 'The confirm password field is required.'
        }
      }
    }
  }
})

Vue.use(VueAxios, axios)

Vue.router = router

// Vue.use(VueAnalytics, {
//   id: 'UA-10262863-29',
//   router,
//   debug: {
//     sendHitTask: process.env.NODE_ENV === 'production'
//   }
// })

Vue.axios.defaults.baseURL = process.env.VUE_APP_ROOT_API

Vue.axios.interceptors.response.use(
  response => {
    // check the header version
    let versionInHeader = response.headers[constants.VERSION] || 'default'
    let versionInStore = store.getters['application/version']
    if (versionInHeader !== versionInStore) {
      store
        .dispatch('application/setVersion', { version: versionInHeader })
        .then(window.location.reload())
    }
    // remove the Axios "data" wrapper
    return response.data
  }
)

const refreshAuthLogic = failedRequest => AuthService.refresh().then(data => {
  failedRequest.response.config.headers['Authorization'] = 'Bearer ' + data.access_token
  return Promise.resolve()
}).catch((error) => {
  localStorage.removeItem('user')
  router.push('/login')
  return Promise.reject(error)
})

createAuthRefreshInterceptor(Vue.axios, refreshAuthLogic)

Vue.component('mugen-scroll', MugenScroll)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
